export const appDesignTokens = {
  fonts: {
    body: "'Manrope', sans-serif",
    heading: "'Playfair Display', serif",
    mono: "'JetBrains Mono', monospace",
  },
  colors: {
    background: '#f8fafc',
    appShell: '#eef2fb',
    surface: '#ffffff',
    surfaceSubtle: '#f1f5f9',
    surfaceInset: '#f8fafc',
    textPrimary: '#0f172a',
    textSecondary: '#475569',
    textMuted: '#64748b',
    textDim: '#94a3b8',
    border: '#e2e8f0',
    cardBorder: '#f1f5f9',
    accent: '#2563eb',
    accentStrong: '#1d4ed8',
    success: '#059669',
    successSoft: 'rgba(16,185,129,0.08)',
    successBorder: 'rgba(16,185,129,0.2)',
    danger: '#EF4444',
  },
  gradients: {
    primaryButton: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
    heroGlow: 'radial-gradient(ellipse 70% 40% at 50% 100%, rgba(37,99,235,0.04) 0%, transparent 70%)',
  },
  radius: {
    sm: 8,
    md: 10,
    lg: 12,
    card: 14,
    featureCard: 18,
    modal: 24,
    pill: 999,
  },
  shadow: {
    card: '0 10px 30px rgba(0,0,0,0.03)',
    raised: '0 12px 32px rgba(59,130,246,0.15)',
    menu: '0 12px 36px rgba(37,99,235,0.18)',
    modal: '0 20px 60px rgba(37,99,235,0.16)',
    primaryButton: '0 8px 40px rgba(37,99,235,0.25)',
  },
  spacing: {
    pageX: 28,
    pageY: 20,
    card: 18,
    sectionGap: 28,
    controlGap: 12,
  },
};

export const getAppDesignTheme = () => appDesignTokens;
